const packages = [
  {
    id: 1,
    title: "Paket Sweet",
    description:
      "Paket photoboth sederhana yang cocok untuk acara kecil atau kebutuhan ringan.",
    originalPrice: 285000,
    price: 285000,
    features: [
      "Online Photobooth",
      "Unlimited Akses & Upload",
      "Text Message",
      "Custom Frame (Polaroid)",
      "QR Code (Desain Template)",
      "Masa Aktif 5 hari"
    ],
  },
  {
    id: 2,
    title: "Paket Grand",
    description:
      "Paket photobooth lengkap untuk acara yang ingin tampil lebih rapi dan profesional.",
    originalPrice: 420000,
    price: 420000,
    features: [
      "Online Photobooth",
      "Unlimited Akses & Upload",
      "Text Message",
      "Voice Message",
      "Custom Frame",
      "QR Code Custom",
      "Masa Aktif 10 hari"
    ],
  },
  {
    id: 3,
    title: "Paket Ultimate",
    description:
      "Paket photobooth premium dengan layanan maksimal untuk acara spesial.",
    originalPrice: 590000,
    price: 590000,
    features: [
      "Online Photobooth",
      "Multiple Photo",
      "Unlimited Akses & Upload",
      "Text Message",
      "Voice Message",
      "Custom Frame",
      "QR Code Custom",
      "Owner-Only Photo (Opsional)",
      "Masa Aktif 15 hari"
    ],
  },
];

export default packages;
